// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixWindow from 'wix-window';

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function pgAbout_viewportEnter(event) {
	if(wixWindow.formFactor === "Mobile"){
		$w("#txtAbout").show();
	$w("#txtExpertize").hide();
	$w("#txtProjects").hide();
	$w("#txtJobs").hide();
  	$w("#txtContact").hide();
	}
	//Add your code for this event here: 
}